export enum ApiArticleEANUnitType {
  Multi = 'G',
  Single = 'H',
}

export interface ApiArticleEAN {
  ID: number;
  DBID: number;
  ArtikelNr: string;
  EANCode: string|null;
  Kommentar: string|null;
  EinheitTyp?: ApiArticleEANUnitType;
}
